import { ref, computed } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useInformeBases() {
    const loading = ref(true);
    const informe = ref([]);
    const detalle = ref([]);
    const totalBases = ref(0);
    const totalRecaudacion = ref(0);
    const ventaDiaria = ref([]);
    const valoresRenovaciones = ref([]);
    const devoluciones = ref([]);
    const devolucionesDetalle = ref([]);

    const totales = computed(() => ({
        totalBases: totalBases.value,
        totalRecaudacion: totalRecaudacion.value
    }));

    const valoresVentaDiariaGrafica = computed(() => {
        if (!ventaDiaria.value?.length) return [];
        const rows = [['Fecha', 'Total']];
        ventaDiaria.value.forEach(item => {
            rows.push([item.date || item.fecha, Number(item.total) || 0]);
        });
        return rows;
    });

    const desglose = computed(() => {
        if (!informe.value?.length) return [];
        // Matches legacy setDesglose(): sums item.total per categoria
        const cats = [];
        const totals = [];
        informe.value.forEach(item => {
            const cat = item.categoria || 'Sin categoría';
            const idx = cats.indexOf(cat);
            if (idx === -1) {
                cats.push(cat);
                totals.push(Number(item.total) || 0);
            } else {
                totals[idx] += Number(item.total) || 0;
            }
        });
        const rows = [['Categoría', 'Vendidos']];
        cats.forEach((cat, i) => {
            rows.push([cat, totals[i]]);
        });
        return rows;
    });

    const renovacionesData = computed(() => {
        if (!valoresRenovaciones.value) return [];
        const rows = [['Estado', 'Cantidad']];
        if (Array.isArray(valoresRenovaciones.value)) {
            valoresRenovaciones.value.forEach(item => {
                rows.push([item.label || item.estado, Number(item.value || item.cantidad || 0)]);
            });
        } else {
            const data = valoresRenovaciones.value;
            if (data.renovados !== undefined) rows.push(['Renovados', Number(data.renovados)]);
            if (data.nuevos !== undefined) rows.push(['Nuevos', Number(data.nuevos)]);
        }
        return rows;
    });

    async function fetch(fechaInicio, fechaFin, listaId) {
        loading.value = true;
        try {
            const params = {
                filters: { fecha_inicio: fechaInicio, fecha_fin: fechaFin, lista_id: listaId },
                lista_id: listaId
            };
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.informe'),
                params
            );
            const data = res.data;
            informe.value = data.informe || [];
            detalle.value = data.detalle || [];
            totalBases.value = data.total_bases || 0;
            totalRecaudacion.value = data.total_recaudacion || 0;
            ventaDiaria.value = data.venta_diaria || [];
            valoresRenovaciones.value = data.estado_renovaciones || [];
            devoluciones.value = data.devoluciones || [];
            devolucionesDetalle.value = data.devoluciones_detalle || [];
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error('Error fetching informe bases:', error);
        } finally {
            loading.value = false;
        }
    }

    return {
        loading,
        informe,
        detalle,
        totales,
        ventaDiaria,
        valoresRenovaciones,
        devoluciones,
        devolucionesDetalle,
        valoresVentaDiariaGrafica,
        renovacionesData,
        desglose,
        fetch
    };
}
